import {
  ActivitiesPageFilters,
  DurationFilter,
} from "domain/entities/activities.entities";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Seance } from "ui/pages/app/seances/seance/Seance";
import { Seances } from "ui/pages/app/seances/Seances";

export function SeancesContainer() {
  const [searchParams] = useSearchParams();
  const [filters, setFilters] = useState<
    ActivitiesPageFilters & {
      [key: string]: string[] | string | boolean | number | DurationFilter;
    }
  >({
    participants: "",
    modalities: [],
    selectedDuration: "",
    seanceObjectives: [],
  });

  return searchParams.get("id") ? (
    <Seance selectedSeanceId={searchParams.get("id")} />
  ) : (
    <Seances filters={filters} setFilters={setFilters} />
  );
}
